module.exports = __webpack_public_path__ + "static/media/article4.77141534.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article4.jpeg
// module id = 93
// module chunks = 0